import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Autumn/MultiplicationAndDivisionA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionA',
  field: 'Number',
  weeks: [9, 11],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/1MultiplesOf3" */ './1MultiplesOf3'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/2MultiplyAndDivideBy6" */ './2MultiplyAndDivideBy6'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/3Num6TimesTableAndDivisionFacts" */ './3Num6TimesTableAndDivisionFacts'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/4MultiplyAndDivideBy9" */ './4MultiplyAndDivideBy9'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/5Num9TimesTableAndDivisionFacts" */ './5Num9TimesTableAndDivisionFacts'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/6The36And9TimesTables" */ './6The36And9TimesTables'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/7MultiplyAndDivideBy7" */ './7MultiplyAndDivideBy7'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/8Num7TimesTableAndDivisionFacts" */ './8Num7TimesTableAndDivisionFacts'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/9Num11TimesTableAndDivisionFacts" */ './9Num11TimesTableAndDivisionFacts'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/10Num12TimesTableAndDivisionFacts" */ './10Num12TimesTableAndDivisionFacts'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/11MultiplyBy1And0" */ './11MultiplyBy1And0'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/12DivideANumberBy1AndItself" */ './12DivideANumberBy1AndItself'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Autumn/MultiplicationAndDivisionA/13MultiplyThreeNumbers" */ './13MultiplyThreeNumbers'
        )
    })
  ]
});
export default Block;
